import React,{useEffect, useState} from 'react'
import Loading from '../components/LoadingComponent'
import ErrorMessageComponent from '../components/ErrorMessageComponent'
import A12Y_CONST from '../common/a12yConst';
import { useForm } from 'react-hook-form';
import { withRouter } from "react-router";
import {client} from "../config/axiosClient";
import EditChangesRemovePopup from '../components/EditChangesRemovePopup'

function  ForgotPasswordEmailScreen(props) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const {register, handleSubmit, clearErrors, setFocus, formState:{ errors},setValue} = useForm({mode:"all"});
    const [userName, setUserName] = useState('');
    const [isBtnDisabled, setIsBtnDisabled] = useState(false);
    const [isPopUpVisible, setIsPopUpVisible] = useState(false);

    useEffect(() => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const email = params.get('uname');
        if(email){
            setUserName(email)
            setValue("username",email)
            setIsBtnDisabled(true)
        }
        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', function (event){
            window.history.pushState(null, document.title,  window.location.href);
        });
    },[]) // eslint-disable-line react-hooks/exhaustive-deps

    const onSubmit = async () => {
        setIsBtnDisabled(false)
        setError(false)
        setLoading(true)
        let response = await client.post(A12Y_CONST.API_ENDPOINT.FORGOT_PASSWORD, {
            "username" : userName,
        });
        setLoading(false)
        setIsBtnDisabled(true)
        if (!response.data.error && response.data.status === A12Y_CONST.API_RESPONSE_STATUS.OK) {
            window.gtag('event', 'forget_password_init', {

            });
            props.history.push({
                pathname : A12Y_CONST.ROUTE.FORGOT_PASSWORD_VARIFICATION_CODE,
                state : {
                    'username' : userName,
                }
            })
        }else {
            setError(true);
            window.gtag('event', 'forget_password_init_failed', {

            });
            setErrorMessage(response.data.sr?.a12yErr?.message)
        }
    }

    useEffect(() => {
        setFocus("username");
    }, [setFocus])

    const handleUserName = (value) => {
        if(value.length >= 1){
            setIsBtnDisabled(true)
        }else{
            setIsBtnDisabled(false)
        }
        
        if(value.length === 1 && value === " "){
            return
        }else{
            setValue("username",value)
            setUserName(value);
        }
    }

    const handleHidePopup = () => {
        setIsPopUpVisible(false);
    }


    const handleResetAllFields = async () => {
        setIsPopUpVisible(false);
        props.history.push(A12Y_CONST.ROUTE.LOGIN);
    }

    const onCancel = async()=>{
        setIsPopUpVisible(true);
    }


    return (
        <div className="signColCenter fullWidth">
            {loading ?
                <div className="transparentLayer"></div>
                :
                null
            }
            <div className='fullWidth texAlingCener'>
                <div className="emailVerificationIcon marginTop20">
                    <svg width="59" height="63" viewBox="0 0 59 63" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_8654_58347)">
                            <path d="M49.6547 63C49.5577 62.8104 49.3468 62.8304 49.1929 62.7518C48.6871 62.4944 48.2856 62.0701 48.0561 61.5505C47.8267 61.0309 47.7834 60.4479 47.9336 59.9C48.0838 59.3521 48.4183 58.873 48.8805 58.5435C49.3427 58.2141 49.9043 58.0546 50.4704 58.092C51.046 58.1421 51.5857 58.3932 51.9951 58.8015C52.4045 59.2098 52.6575 59.7493 52.7099 60.3256C52.7598 60.8908 52.6105 61.4556 52.2881 61.9222C51.9656 62.3887 51.4902 62.7275 50.9445 62.8797C50.866 62.9028 50.7905 62.9013 50.7613 63H49.6547Z" fill="#D86941"/>
                            <path d="M47.8167 51.1618C47.7198 49.4493 48.0969 47.7491 49.2774 46.2816C49.8896 45.5089 50.6747 44.8911 51.5692 44.4781C52.7882 43.9186 53.6593 43.0708 53.9718 41.7236C54.0908 41.2324 54.1107 40.7223 54.0305 40.2233C53.9503 39.7242 53.7715 39.2462 53.5045 38.8172C53.2376 38.3882 52.8879 38.0169 52.476 37.7248C52.064 37.4328 51.598 37.226 51.1053 37.1165C50.6125 37.0071 50.103 36.9971 49.6063 37.0873C49.1097 37.1774 48.636 37.3658 48.213 37.6415C47.79 37.9172 47.4261 38.2747 47.1427 38.6929C46.8592 39.1112 46.6619 39.5818 46.5623 40.0773C46.507 40.3799 46.4711 40.6858 46.4546 40.993C46.3376 42.3664 45.2633 43.3591 43.9273 43.3205C43.2863 43.2969 42.6798 43.0237 42.2369 42.559C41.7939 42.0944 41.5494 41.475 41.5555 40.8326C41.4955 36.623 44.8108 32.7894 48.9942 32.2345C53.6424 31.6179 57.7427 34.448 58.797 38.9999C59.6528 42.6993 57.7904 46.7641 54.4397 48.5152C54.1134 48.6863 53.7855 48.8527 53.4746 49.0485C52.9436 49.3861 52.7435 49.9086 52.7374 50.5159C52.7297 51.1926 52.7482 51.8693 52.7297 52.5445C52.6912 53.9472 51.6184 55.0108 50.2671 55C48.9157 54.9892 47.8768 53.9503 47.8198 52.5784C47.8013 52.1499 47.8167 51.7183 47.8167 51.1618Z" fill="#D86941"/>
                            <path d="M13.7723 45.0362C13.2872 45.0343 12.8136 44.8885 12.4113 44.6173C12.009 44.346 11.6959 43.9613 11.5118 43.5119C11.3277 43.0625 11.2807 42.5685 11.3767 42.0924C11.4728 41.6163 11.7077 41.1793 12.0516 40.8368C12.3955 40.4943 12.8331 40.2616 13.3091 40.1681C13.7851 40.0745 14.278 40.1244 14.7257 40.3113C15.1734 40.4983 15.5557 40.8139 15.8243 41.2184C16.0929 41.6228 16.2358 42.098 16.2349 42.5837C16.2313 43.2354 15.9702 43.8592 15.5087 44.3187C15.0473 44.7782 14.423 45.0362 13.7723 45.0362Z" fill="#112E53"/>
                            <path d="M25.4478 42.579C25.4478 43.0646 25.3041 43.5392 25.035 43.9431C24.7658 44.3469 24.3832 44.6619 23.9354 44.8481C23.4876 45.0343 22.9948 45.0835 22.5192 44.9895C22.0435 44.8954 21.6063 44.6623 21.2629 44.3196C20.9194 43.9769 20.685 43.54 20.5893 43.064C20.4936 42.588 20.5409 42.0942 20.7251 41.6451C20.9094 41.196 21.2224 40.8116 21.6247 40.5405C22.0269 40.2694 22.5003 40.1238 22.9852 40.1219C23.6358 40.1248 24.2592 40.3842 24.7202 40.8442C25.1811 41.3041 25.4425 41.9274 25.4478 42.579Z" fill="#112E53"/>
                            <path d="M32.246 40.122C32.731 40.1297 33.2029 40.2812 33.602 40.5573C34.0011 40.8335 34.3094 41.2219 34.4881 41.6736C34.6668 42.1252 34.7079 42.6198 34.606 43.0947C34.5041 43.5697 34.2639 44.0038 33.9158 44.3421C33.5677 44.6804 33.1272 44.9077 32.6501 44.9954C32.173 45.0831 31.6806 45.0272 31.2353 44.8347C30.7899 44.6422 30.4115 44.3219 30.1478 43.9141C29.8842 43.5063 29.7472 43.0293 29.7542 42.5436C29.7695 41.8933 30.0393 41.2751 30.5054 40.8222C30.9715 40.3692 31.5966 40.1178 32.246 40.122Z" fill="#112E53"/>
                            <path d="M49.0059 24.066C48.783 23.7775 48.4969 23.5442 48.1698 23.3838C47.8426 23.2235 47.4831 23.1404 47.1189 23.1411H42.6169C42.3583 23.101 42.2614 22.9654 42.266 22.5708C42.2952 19.9673 42.2829 17.3638 42.2783 14.7603C42.2973 13.18 42.0592 11.6072 41.5734 10.1036C40.426 6.68003 38.0692 3.79418 34.9462 1.9888C31.8232 0.183407 28.1492 -0.417134 24.6151 0.300105C17.6889 1.7136 12.7144 7.64813 12.7914 14.731C12.8191 17.3345 12.7914 19.9395 12.8052 22.543C12.8052 22.9962 12.7314 23.1827 12.2204 23.1596C11.3231 23.1133 10.4196 23.1303 9.51917 23.1596C4.34457 23.3199 0.0965359 27.5373 0.0457441 32.7196C-0.0219782 39.6283 -0.0081259 46.5385 0.0457441 53.4473C0.0749879 57.455 2.72078 61.0357 6.49168 62.3876C7.15043 62.625 7.83227 62.7961 8.50334 63.0041H40.9408C40.9639 62.9055 41.0455 62.907 41.124 62.8839C41.4398 62.796 41.7345 62.6447 41.9902 62.4393C42.2459 62.2338 42.4573 61.9785 42.6115 61.6887C42.7656 61.399 42.8594 61.0809 42.887 60.7537C42.9147 60.4266 42.8757 60.0972 42.7724 59.7856C42.4291 58.7066 41.4857 58.09 40.1481 58.09H10.2303C7.00575 58.09 4.93868 56.0184 4.93714 52.7891C4.93714 46.3304 4.93714 39.8723 4.93714 33.4148C4.93714 30.1392 6.9919 28.0752 10.2533 28.0752H44.8949C45.0457 28.0752 45.1965 28.0783 45.3474 28.0845H47.1189C47.7516 28.0845 48.3584 27.8328 48.8058 27.3847C49.2532 26.9366 49.5046 26.3289 49.5046 25.6952V25.5411C49.5084 25.0073 49.3327 24.4877 49.0059 24.066ZM37.0822 23.1411C37.0124 23.1519 36.9419 23.1566 36.8713 23.155C35.6564 23.1488 34.442 23.1457 33.2281 23.1457C31.3124 23.1457 29.3967 23.1457 27.481 23.1457C24.4119 23.1457 21.3429 23.1365 18.2738 23.1565C17.8336 23.1565 17.692 23.0794 17.6966 22.6C17.7244 19.958 17.6966 17.3145 17.712 14.6709C17.7088 13.2754 18.0058 11.8956 18.583 10.6255C19.1602 9.35538 20.004 8.22475 21.0568 7.31064C22.1096 6.39652 23.3468 5.72039 24.6841 5.32829C26.0214 4.9362 27.4273 4.83735 28.8062 5.03848C33.9115 5.746 37.3608 9.69824 37.3654 14.8435C37.3654 17.4455 37.3561 20.0474 37.3746 22.6494C37.3777 22.9685 37.3115 23.0979 37.0822 23.138V23.1411Z" fill="#112E53"/>
                            <path d="M37.0825 23.137C37.0128 23.1478 36.9422 23.1524 36.8717 23.1508C35.6568 23.1447 34.4424 23.1416 33.2285 23.1416H33.3624L37.0825 23.137Z" fill="#112E53"/>
                            <path d="M45.3465 28.0695H33.3612C33.2981 28.0695 33.2334 28.0695 33.1719 28.0695H44.894C45.0448 28.0592 45.1957 28.0592 45.3465 28.0695Z" fill="#112E53"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_8654_58347">
                                <rect width="59" height="63" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>

                </div>
                <h2 className="title1 texAlingCener">
                    {A12Y_CONST.MESSAGE.FORGOT_PASSWORD_EMAIL_TITLE}
                </h2>
                <div className="fullWidth marginBottom20">
                <div className="emailVerificationMessage">
                    {A12Y_CONST.MESSAGE.FORGOT_PASSWORD_EMAIL_MESSAGE}
                </div>
                </div>
                {error &&
                <ErrorMessageComponent errorMessage={errorMessage}/>
                }
                <div className="inputColField onlyNumber fullWidth marginTop80 forgotPassdependentInput768">
                    <form autoComplete="off" className='signUpFlow' onSubmit={handleSubmit(onSubmit)}>
                        <div className={'fullWidth positionRelative forgotPassWidth marginBottom80'}>
                            <label className='texAlingLeft fullWidth'>{A12Y_CONST.LABEL.EMAIL}</label>
                            <input
                                {...register('username', { required: A12Y_CONST.ERROR_MESSAGE.EMAIL_REQUIRED , pattern:{
                                    //value:/^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9]{0,61}$/,
                                    //eslint-disable-next-line
                                    value:/^\w+([\+.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                                    message:A12Y_CONST.ERROR_MESSAGE.SIGNUP_USERNAME_INVALID
                                }})}
                                placeholder='Email'
                                className={errors.username ? 'inputColum errorInputBorderRed': 'inputColum'}
                                type='email'
                                id='userEmail'
                                onChange={(e) => handleUserName(e.target.value)}
                                value={userName}
                                onFocus={()=>{
                                    clearErrors("username")
                                }}
                            />
                            <div className='errorRelativeRow'>{errors.username && <p className='errorMessage'>{errors.username.message}</p>}</div>
                        </div>
                        <div className='fullWidth'>
                            <div className='marginTop25 loaderSpinner8radius'>
                        {loading ?
                            <Loading />
                            :
                            null
                        }
                        <input id={A12Y_CONST.BUTTON_ID.SEND_BUTTON_FORGOT_PASSWORD} className={!isBtnDisabled ? "buttonDisable" :'button'} disabled={!isBtnDisabled}  type="submit"  value={ !loading ? A12Y_CONST.BUTTON_TEXT.FORGOT_PASSWORD_EMAIL_SEND : A12Y_CONST.BUTTON_TEXT.FORGOT_PASSWORD_EMAIL_SENDING}/></div>
                        </div>
                        <div className='cancelButton fullWidth marginTop30 marginBottom20'><span id={A12Y_CONST.BUTTON_ID.CANCEL_BUTTON_FORGOT_PASSWORD}  onClick={onCancel}>Cancel</span></div>
                    </form>

                </div>

            </div>
            <EditChangesRemovePopup
                title={A12Y_CONST.MESSAGE.FORGOT_PASSWORD_POPUP_TITLE}
                message={A12Y_CONST.MESSAGE.FORGOT_PASSWORD_POPUP_MESSAGE}
                popUpStatus={isPopUpVisible}
                hidePopUp={handleHidePopup}
                resetAllFields={handleResetAllFields}
            />
        </div>
    )

}


export default withRouter (ForgotPasswordEmailScreen);
